<template>
    <!-- 医生管理 -->
    <div id="docManage" class="sys-page">
        <div class="breadcrumb">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item to="/hospManage">医院管理</el-breadcrumb-item>
                <el-breadcrumb-item to="/hospDetail">医院信息</el-breadcrumb-item>
                <el-breadcrumb-item>医生管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="tableBox">
            <div class="btn">
                <el-button type="primary" @click="addNew=true">添加医生</el-button>
            </div>
            <div>
                <el-table :data="tableData.body" border style="width: 98%;margin:0 auto">
                    <el-table-column header-align=center align="center" type=index label="序号" width="50"></el-table-column>
                    <el-table-column header-align=center align="center" prop="userName" label="姓名"></el-table-column>
                    <el-table-column header-align=center align="center" prop="docGender" label="性别" :formatter="sexFormat"></el-table-column>
                    <el-table-column header-align=center align="center" prop="docTel" label="手机号"></el-table-column>
                    <el-table-column header-align=center align="center" prop="userStatus" label="是否启用">
                        <template slot-scope="scope">
                            <el-switch v-model="scope.row.userStatus"
                                        :disabled="scope.row.roleCode.indexOf('gly')>-1"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949" 
                                        active-value="01" 
                                        inactive-value="02"
                                        @change="change(scope.row)">
                            </el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column align =center label="操作" header-align=center width="240">
                        <template slot-scope="scope">
                            <el-button type="primary" :disabled="scope.row.roleCode.indexOf('gly')>-1" size="small" @click="editMsg(scope.row)">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page">
                <el-pagination  :page-size="20" :page-count="5" layout="total, prev, pager, next" :total="tableData.count" @current-change='currentChange' style="text-align:right"></el-pagination>
            </div>
        </div>
        <el-dialog title="添加医生" :visible.sync="addNew" width="650px" center @close='clear'>
            <el-form ref="newDoc" :model="newDoc" :rules="newDocRules" label-width="110px">
                <el-form-item label="手机号" prop="docTel">
                    <el-input type="text" placeholder="请输入手机号，该手机号将作为账号登陆使用" v-model="newDoc.docTel"></el-input>
                </el-form-item>
                <el-form-item label="医生编号" prop="docCode">
                    <el-input type="text" placeholder="请输入医生编号" v-model="newDoc.docCode"></el-input>
                </el-form-item>
                <el-form-item label="医生姓名" prop="docName">
                    <el-input type="text" :disabled="newDocFlag" placeholder="请输入医生姓名" v-model="newDoc.docName"></el-input>
                </el-form-item>
                <el-form-item label="医生性别" prop="docGender">
                    <el-radio-group :disabled="newDocFlag" v-model="newDoc.docGender">
                        <el-radio label="M">男</el-radio>
                        <el-radio label="F">女</el-radio>
                        <el-radio v-if="newDocFlag" label="O">未定义</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="角色(可多选)" prop="roleId">
                    <el-checkbox-group v-model="newDoc.roleId">
                        <el-checkbox v-for="item in roleList" :label="item.roleId" :key="item.roleId">{{item.roleName}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input :type="type" :disabled="newDocFlag" placeholder="请输入密码" v-model="newDoc.password"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="rePassword">
                    <el-input :type="type" :disabled="newDocFlag" placeholder="请再次输入密码" v-model="newDoc.rePassword"></el-input>
                </el-form-item>
                <el-form-item style="text-align:right;">
                    <el-button type="primary" @click="submit()">保存</el-button>
                </el-form-item>
                <p style="margin-left:20px;">* 申请医师：即本医院填写病历，上传心电文件，向其他医院进行申请、提交病历的医生</p>
                <p style="margin-left:20px;">* 诊断医师：即本医院对其他医院申请提交的病历进行诊断的医生</p>
            </el-form>
        </el-dialog>
        <el-dialog title="编辑医生" :visible.sync="editNew" width="600px" center>
            <el-form ref="editDoc" :model="editDoc" :rules="editDocRules" label-width="100px">
                <el-form-item label="医生编号">
                    <el-input type="text" disabled v-model="editDoc.docCode"></el-input>
                </el-form-item>
                <el-form-item label="医生姓名">
                    <el-input type="text" disabled v-model="editDoc.userName"></el-input>
                </el-form-item>
                <el-form-item label="医生性别">
                    <el-radio-group disabled v-model="editDoc.docGender">
                        <el-radio label="M">男</el-radio>
                        <el-radio label="F">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="角色(多选)" prop="roleId">
                    <el-checkbox-group v-model="editDoc.roleId">
                        <el-checkbox v-for="item in roleList" :label="item.roleId" :key="item.roleId">{{item.roleName}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="手机">
                    <el-input type="text" disabled v-model="editDoc.docTel" placeholder="该手机号将作为账号登录使用"></el-input>
                </el-form-item>
                <el-form-item style="text-align:right;">
                    <el-button type="primary" @click="save()">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import {isvalidPhone} from '@/service/common'
import { Loading } from 'element-ui';
//定义一个全局的变量，手机号验证
var validPhone=(rule, value,callback)=>{
    if (!value){
        callback(new Error('请输入电话号码'))
    }else  if (!isvalidPhone(value)){
        callback(new Error('手机号码格式不对'))
    }else {
        callback()
    }
}
export default {
    name:'docManage',
    data(){
        return{
            hospMsg:'',
            roleList:[],
            tableData:{
                count:10,
                body:[]
            },
            addNew:false,
            newDocFlag:false,
            type:'password',
            newDoc:{
                docCode:'',//编号
                docName:'',//姓名
                docGender:'',//性别
                docTel:'',//手机号
                proRank:'',//职称
                hospDeptRelId:'',//科室id
                hospId:'',
                roleId:[],//权限
                password:'',//密码
                rePassword:'',//确认密码
                userStatus:'01'
            },
            newDocRules:{
                docCode:[{ required: true, message: '请输入医生编号', trigger: 'blur' }],
                docName:[{ required: true, message: '请输入医生姓名', trigger: 'blur' }],
                docGender:[{ required: true, message: '请选择医生性别', trigger: 'blur' }],
                docTel:[{ required: true, trigger: 'blur', validator: validPhone },
                        { required: true, message: '请输入手机号', trigger: 'blur' }],
                proRank:[{ required: true, message: '请选择医生职称', trigger: 'change' }],
                hospDeptRelId:[{ required: true, message: '请选择所属科室', trigger: 'blur' }],
                roleId:[{ required: true, message: '请选择医生角色', trigger: 'change' }],
                password:[{ required: true, message: '请输入密码', trigger: 'blur' },{min:6, message: '密码不得小于六位', trigger: 'blur'}],
                rePassword:[{ required: true, message: '请输入密码', trigger: 'blur' },{min:6, message: '密码不得小于六位', trigger: 'blur'}]
            },
            editNew:false,
            editDoc:{},
            editDocRules:{
                proRank:[{ required: true, message: '请选择医生职称', trigger: 'change' }],
                hospDeptRelId:[{ required: true, message: '请选择所属科室', trigger: 'blur' }],
                roleIds:[{ required: true, message: '请选择医生角色', trigger: 'change' }]
            },
            loadingInstance:''
        }
    },
    mounted(){
        this.hospMsg=this.$common.getStorage('hospMsg');
        this.newDoc.hospId=this.hospMsg.hospId;
        this.getDocList(1);
        this.getRoleList();
    },
    methods:{
        //医生的启用、禁用
        change(row){
            //禁用医生
            if(row.userStatus=='02'){
                this.loadingInstance=Loading.service({
                    text:'医生禁用中，请稍后',
                    spinner:'el-icon-loading',
                    background:'rgba(0, 0, 0, 0.8)'
                });
                this.$ajax.post(this.$domain.updateUserInfo,{
                    userId:row.userId,
                    userStatus:'02'
                })
                .then(ret=>{
                    this.loadingInstance.close();
                    this.$common.getConsole('docAdmin.vue--禁用医生',ret.data)
                    if(ret.data.code==10){
                        this.$message.success('医生禁用成功!')
                    }
                    else{
                        this.$message.error(ret.data.message);
                        row.userStatus='01'
                    }
                })
                .catch(err=>{
                    this.loadingInstance.close();
                })
            }
            //启用医生
            else{
                this.loadingInstance=Loading.service({
                    text:'医生启用中，请稍后',
                    spinner:'el-icon-loading',
                    background:'rgba(0, 0, 0, 0.8)'
                });
                this.$ajax.post(this.$domain.updateUserInfo,{
                    userId:row.userId,
                    userStatus:'01'
                })
                .then(ret=>{
                    this.loadingInstance.close();
                    this.$common.getConsole('docAdmin.vue--启用医生',ret.data)
                    if(ret.data.code==10){
                        this.$message.success('医生启用成功!')
                    }
                    else{
                        this.$message.error(ret.data.message);
                        row.userStatus='02'
                    }
                })
                .catch(()=>{
                    this.loadingInstance.close();
                })
            }
        },
        //分页
        currentChange(val){
            this.getDocList(val);
        },
        //获得医生列表
        getDocList(page){
            this.$ajax.post(this.$domain.queryUserFromHosp,{
                hospId:this.hospMsg.hospId,
                page:page,
                rows:20
            })
            .then(ret=>{
                this.$common.getConsole('docAdmin.vue--获得医生列表',ret.data)
                if(ret.data.code==10){
                    this.tableData.body=ret.data.data.list;
                    this.tableData.count=ret.data.data.count;
                }
                else if(ret.data.code=='401'){
                    this.$message.error('登录失效，请重新登录!')
                    this.$router.push({path:'/login'});
                }
                else if(ret.data.code!='11'){
                    this.$message.error(ret.data.message);
                }
            })
        },
        //根据手机号查询医生信息
        queryDoc(tel){
            if (!isvalidPhone(tel)||!tel){
                return;
            }
            this.loadingInstance=Loading.service({
                text:'手机号查询中，请稍后...',
                spinner:'el-icon-loading',
                background:'rgba(0, 0, 0, 0.8)'
            });
            this.$ajax.post(this.$domain.judgeDocIsExist,{
                phone:tel
            })
            .then(ret=>{
                this.loadingInstance.close();
                if(ret.data.code==10){
                    this.$message.error('该手机号已被使用！')
                }
                else if(ret.data.code=='401'){
                    this.$message.error('登录失效，请重新登录!')
                    this.$router.push({path:'/login'});
                }
                else{
                    this.newDocFlag=false;
                    this.newDoc.password=''
                    this.newDoc.rePassword=''
                    this.type="password";
                    this.$message.success('该手机号第一次使用！')
                }
            })
            .catch(err=>{
                this.loadingInstance.close();
            })
        },
        //添加医生
        submit(){
            this.$refs['newDoc'].validate((valid) => {
                if (valid) {
                    if(this.newDoc.password.length<6){
                        this.$message.error('密码不得少于六位!');
                        return;
                    }
                    if(this.newDoc.password!=this.newDoc.rePassword){
                        this.$message.error('两次密码输入不一致');
                        return;
                    }
                    this.loadingInstance=Loading.service({
                        text:'医生创建中，请稍后',
                        spinner:'el-icon-loading',
                        background:'rgba(0, 0, 0, 0.8)'
                    });
                    let obj={
                        docCode:this.newDoc.docCode,//编号
                        docName:this.newDoc.docName,//姓名
                        docGender:this.newDoc.docGender,//性别
                        docTel:this.newDoc.docTel,//手机号
                        hospId:this.hospMsg.hospId,
                        roleId:this.newDoc.roleId,//权限
                        password:this.$common.pwd99(this.newDoc.password),//密码
                        // rePassword:this.$common.pwd99(this.newDoc.rePassword),//确认密码
                        userStatus:'01'
                    }
                    this.loadingInstance=Loading.service({
                        text:'医生创建中，请稍后',
                        spinner:'el-icon-loading',
                        background:'rgba(0, 0, 0, 0.8)'
                    });
                    this.$ajax.post(this.$domain.openUserAccount,obj)
                    .then(ret=>{
                        this.loadingInstance.close();
                        this.$common.getConsole('docAdmin.vue--添加医生',ret.data)
                        if(ret.data.code==10||ret.data.code==115){
                            this.$message.success('添加成功');
                            this.clear();
                            this.getDocList(1);
                        }
                        else if(ret.data.code=='14'){
                            this.$message.error('医生已存在，不可重复添加！');
                        }
                        else if(ret.data.code=='401'){
                            this.$message.error('登录失效，请重新登录!')
                            this.$router.push({path:'/login'});
                        }
                        else if(ret.data.code!='11'){
                            this.$message.error(ret.data.message);
                        }
                    })
                    .catch(err=>{
                        this.loadingInstance.close();
                    })
                } else {
                    this.$message.error('表单信息不完整!')
                    return false;
                }
            })
                    
        },
        editMsg(row){
            this.editDoc=row;
            this.editNew=true;
        },
        //修改保存医生信息
        save(){
            this.$refs['editDoc'].validate((valid) => {
                if (valid) {
                    this.loadingInstance=Loading.service({
                        text:'医生信息保存中，请稍后',
                        spinner:'el-icon-loading',
                        background:'rgba(0, 0, 0, 0.8)'
                    });
                    this.$ajax.post(this.$domain.updateUserInfo,this.editDoc)
                    .then(ret=>{
                        this.loadingInstance.close();
                        this.$common.getConsole('docAdmin.vue--修改保存医生信息',ret.data)
                        if(ret.data.code==10){
                            this.$message.success('修改成功');
                            this.editNew=false;
                            this.editDoc={};
                            this.getDocList(1);
                        }
                        else if(ret.data.code=='401'){
                            this.$message.error('登录失效，请重新登录!')
                            this.$router.push({path:'/login'});
                        }
                        else if(ret.data.code!='11'){
                            this.$message.error(ret.data.message);
                        }
                    })
                    .catch(err=>{
                        this.loadingInstance.close();
                    })
                } else {
                    this.$message.error('表单信息不完整!')
                    return false;
                }
            })
                    
        },
        //获得角色列表
        getRoleList(){
            this.$ajax.post(this.$domain.queryRoleList,{})
            .then(ret=>{
                this.$common.getConsole('docAdmin.vue--查询公共角色',ret.data)
                if(ret.data.code==10){
                    this.roleList=ret.data.data;
                }
                else if(ret.data.code=='401'){
                    this.$message.error('登录失效，请重新登录!')
                    this.$router.push({path:'/login'});
                }
            })
        },
        //性别转换
        sexFormat(row){
            switch(row.docGender){
                case 'F':return '女';break;
                case 'M':return '男';break;
                case 'O':return '-';break;
            }
        },
        clear(){
            this.addNew=false;
            this.newDocFlag=false;
            this.newDoc={
                docCode:'',//编号
                docName:'',//姓名
                docGender:'',//性别
                docTel:'',//手机号
                proRank:'',//职称
                hospDeptRelId:'',//科室id
                hospId:'',
                roleId:[],//权限
                password:'',//密码
                rePassword:'',//确认密码
                userStatus:'01'
            };
            this.$refs['newDoc'].resetFields();
        }
    }
}
</script>

<style lang="scss" scoped>
#docManage{
    width:100%;
    max-width:1600px;
    min-width:1000px;
    margin:auto;
    padding:20px 40px;
    box-sizing: border-box;
    text-align: center;
    .breadcrumb{
        width:100%;
        margin:20px auto;
        box-sizing: border-box;
    }
    .title{
        font-size: 24px;
        margin-top:30px;
        text-align: left;
        color:#0659C5;
        font-weight: bold;
        padding:10px 10px;
        border-bottom:1px solid #0659C5;
    }
    .tableBox{
        margin-top:20px;
        .btn{
            margin-bottom:10px;
            text-align: right;
            padding:10px;
            box-sizing: border-box;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/docManage.vue